<template>
	<!-- Used for showing an overlay with info on how to use this page -->
	<span class="info-btn"></span>
</template>

<script>
export default {
	name: "InfoButton",
};
</script>

<style scoped>
.info-btn {
    content: '';
	right: 39px;
	top: 55px;
	height: 54px;
    width: 54px;
	position: absolute;
    background-image: url("~@/assets/img/icons/info.svg");
    background-position: center;
	background-repeat: no-repeat;
	z-index: var(--global-z-index-back-btn);
}
</style>